<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 16 16">
    <g transform="translate(-1078 -135)">
      <g transform="translate(1080 136.333)">
        <path d="M15.723,5.625H3.75" transform="translate(-3.75 -2.904)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M9.75,9.75v4" transform="translate(-5.396 -3.811)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M14.25,9.75v4" transform="translate(-6.631 -3.811)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M15.223,5.625v9.25a.529.529,0,0,1-.554.5H5.8a.529.529,0,0,1-.554-.5V5.625" transform="translate(-4.25 -2.042)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M13.25,4.375v-1.5a1,1,0,0,0-1-1h-3a1,1,0,0,0-1,1v1.5" transform="translate(-4.764 -1.875)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconTrash',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>